import { gql } from "@apollo/client";

// NEFT credits received in dealer virtual accounts (server detects NEFT; do NOT
// filter on mnemonicCode in the UI — it is returned for display/debug only).
export const GET_NEFT_CREDIT_PAYMENTS = gql`
  query GetNeftCreditPayments($limit: Int, $offset: Int, $searchTerm: String) {
    getNeftCreditPayments(limit: $limit, offset: $offset, searchTerm: $searchTerm) {
      success
      count
      error
      data {
        id
        amount
        remitterName
        remitterAccount
        remitterBank
        ifscCode
        userReferenceNumber
        transactionDescription
        transactionDate
        valueDate
        virtualAccount
        accountNumber
        mnemonicCode
        debitCredit
      }
    }
  }
`;

// Vehicles with a saved KYC session awaiting payment. searchTerm requires searchType.
export const GET_NEFT_PENDING_VEHICLES = gql`
  query GetNeftPendingVehicles(
    $limit: Int
    $offset: Int
    $searchTerm: String
    $searchType: String
  ) {
    getNeftPendingVehicles(
      limit: $limit
      offset: $offset
      searchTerm: $searchTerm
      searchType: $searchType
    ) {
      success
      count
      error
      data {
        sessionId
        vehicleId
        status
        kycMode
        paymentReceived
        vin
        imei
        engineNumber
        vehicleMake
        vehicleModel
        year
        vehicleStatus
        customerName
        customerMobile
        projectName
        dealerId
        dealerCode
        dealerName
      }
    }
  }
`;

// Raises the KYC from the saved session and flips it to PAYMENT_RECEIVED.
export const RAISE_KYC_FROM_NEFT_SESSION = gql`
  mutation RaiseKycFromNeftSession($sessionId: String!) {
    raiseKycFromNeftSession(sessionId: $sessionId) {
      success
      kyc_id
      message
      error
    }
  }
`;
